import en from 'vuetify/src/locale/en.ts';

export default {
  $vuetify: {
    ...en, //needed to handle $vuetify.noDataText value
    OPERATOR: 'Operator',
    OPERATORANDWALLET: 'Operator / Wallet',
    MOBILENUMBER: 'Mobile Number',
    COUNTRYREQUIRED: 'Country Required',
    OPERATORREQUIRED: 'Operator Required',
    MOBILENUMBERREQUIRED: 'Mobile Number Required',
    PINCODE: 'Verification Code',
    PINCODEREQUIRED: 'PIN Code Required',
    RESENDPIN: 'Resend code',
    ALREADYSUBSCRIBEDERR: 'You are already subscrbied to',
    TERMSOFUSE: 'Terms of use',
    COUNTRY: 'Country',
    INVALIDPINCODE: 'Invalid Pin Code',
    REJECTEDSUBSCRIPTION: 'Subscription Rejected by Merchant',
    ALREADYSUBSCRIBED: 'This user already subscribed to the given product',
    GENERALERRORMESSAGE: 'An error occurred, please try again later',
    PINCODESENTSUCCESS: `The pin code has been sent to your mobile please check again!`,
    PAYBYMOBILE: 'Pay by Mobile',
    CODESENTTO: 'Code sent to ',
    EXPIREDPINCODE: 'Pin Code expired',
    RESENDTRIALSEXCEEDED: 'You have exceeded number of resend pin code',
    INVALIDTRIALSEXCEEDED: 'Exceed Max Attempt Reached Of Invalid Pin',
    INVALIDMSISDN: `Please enter valid phone number for the selected mobile operator.`,
    INVALIDNUMBER: 'Please enter a valid {mobile_label}.',
    GENERALFAILUREMESSAGE: `We couldn't charge you at the moment. Please try again later`,
    RESPONSECODE_1: 'Failed to send verification code, Please try again',
    RESPONSECODE_2: 'Transaction has been cancelled',
    RESPONSECODE_4: "You don't have enough credit",
    RESPONSECODE_5: `Payment value exceeds the maximum allowed value per transaction`,
    RESPONSECODE_9: 'An error occurred, please try again',
    RESPONSECODE_11: 'Invalid PIN code, Please try again',
    RESPONSECODE_19: `Your request timed out, please try purchasing the product again`,
    RESPONSECODE_22: `Please enter valid phone number for the selected mobile operator.`,
    RESPONSECODE_14: `This service is not available to your account, please contact the customer service `,
    RESPONSECODE_16: 'Expired PIN code, Please try again',
    RESPONSECODE_51: 'An error occurred, please try again',
    RESPONSECODE_101: `Wallet is charged successfully but failed to contact the merchant`,
    RESPONSECODE_102: `Transaction can't be completed due to detection of suspicious activity`,
    RESPONSECODE_103: `Your session timed out`,
    RESPONSECODE_104: `This mobile number is blacklisted`,
    RESPONSECODE_105: `Sorry, you cannot use the billing service before consuming at least 200 SAR of your balance in other Mobily services.`,
    RESPONSECODE_202: `Transaction is under processing`,

    FirstName: 'First Name',
    LastName: 'Last Name',
    Email: 'Email',
    AccountNumber: 'Account Number',
    requiredInput: 'Required Field',
    invalidInputFormat: 'Invalid Format',
    UNAUTHORIZEDUSER: 'Unauthorized user',
    EXPIREDSESSION_TITLE: 'Session Expired',
    EXPIREDSESSION_MSG: 'Your session has expired. Please return to the merchant to start over.',

    VATINCLUDED: 'VAT Included',
    VATEXCLUDED: 'VAT Excluded',
    PVATINCLUDED: '{percent}% VAT is Included in the Price',
    PVATEXCLUDED: '{percent}% VAT is excluded from the Price',

    FREETRIALCONSUMED: `You are joining the service with no free trial as you have consumed this offer previously.`,
    PLAN: 'plan',
    DAYSFREETRIAL: 'days free trial!',
    FRAUDTOOLERRORMSG: `Transaction can't be completed due to detection of suspicious activity`,
    MOBILENUMBER_TOO_SHORT_VALIDITY: '{mobile_label} is too short.',
    PINCODE_DIGITS_ONLY: 'PIN Code must be digits only.',
    UNSUBSCRIBE_ERROR_MSG: 'You are not subscribed to {plan_name}',
    PINCODENOTSENT: 'PIN Code not sent',
    PINCODE_LIMITS: 'PIN Code should be between 4-6 digits.',

    OPERATOR_VALIDATION_ALERT: `The selected operator is {operator} {country}.`,
    ENTER_MOBILE_MSG: 'Enter your {operator} Mobile Number',
    TermsCheckbox_MSG:
      'I agree to the terms and conditions and give consent for permission to share my data with Etisalat partners and its affiliates',
    ENTER_PINCODEWITHLENGTH_MSG:
      'Please enter the {pincodeLength}-digit verification code sent to your mobile number {mobileNumber}',
    ENTER_PINCODE_MSG:
      'Please enter the verification code sent to your mobile number {mobileNumber}',
    ChangeNumber: 'Change Number',
    didnotReceiveCodeLbl: `Didn't receive a code?`,
    ResendPinCodeIn: 'Resend in ',
    static_error_title: 'Error',
    static_success_title: 'Congratulation',
    static_pending_title: 'Your request is under processing',
    static_error_body: 'Please try again using the same link you received.',
    static_success_body:
      'Your subscription has been re-authenticated successfully. Please use the same credentials you received previously to access the service.',
    static_pending_body:
      'Please check after a while. you can use the same credentials you received previously to access the service.',
  },
};
